import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBWiDvb3c-ypV3JHrSTYAlzW_RV6LnB7yg",
  authDomain: "paragon-c6794.firebaseapp.com",
  projectId: "paragon-c6794",
  storageBucket: "paragon-c6794.appspot.com",
  messagingSenderId: "941141588633",
  appId: "1:941141588633:web:82dc02f5a6fa0eb02b9608",
  measurementId: "G-XPMD2J476P"
};
  
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };